import { Suspense } from 'react'
import { HashRouter, Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import Menu from '../components/Menu'
import Popups from '../components/Popups'
import Web3ReactManager from '../components/Web3ReactManager'
import AddLiquidity from './AddLiquidity'
import { RedirectDuplicateTokenIds, RedirectOldAddLiquidityPathStructure } from './AddLiquidity/redirects'
import Home from './Home/Home'
import Pool from './Pool'
import PoolFinder from './PoolFinder'
import RemoveLiquidity from './RemoveLiquidity'
import { RedirectOldRemoveLiquidityPathStructure } from './RemoveLiquidity/redirects'
import Swap from './Swap'

const AppWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  overflow-x: hidden;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 32px 16px;
  align-items: center;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1;
  justify-content: center;
  background-repeat: no-repeat;
  background-position: bottom 24px center;
  background-size: 90%;

  ${({ theme }) => theme.mediaQueries.xs} {
    background-size: auto;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    background-repeat: no-repeat;
    background-position: center 420px, 10% 230px, 90% 230px;
    background-size: contain, 266px, 266px;
    min-height: 90vh;
  }
`

const Marginer = styled.div`
  margin-top: 5rem;
`

export default function App() {
  return (
    <Suspense fallback={null}>
      <Web3ReactManager>
        <HashRouter>
          <Switch>
            <Route exact path="/" component={Home} />
            <AppWrapper>
              <Menu>
                <BodyWrapper>
                  <Popups />
                  <Switch>
                    <Route exact path="/find" component={PoolFinder} />
                    <Route exact path="/pool" component={Pool} />
                    <Route exact path="/swap" component={Swap} />
                    <Route exact path="/add" component={AddLiquidity} />
                    <Route exact path="/remove/:currencyIdA/:currencyIdB" component={RemoveLiquidity} />
                    <Route exact path="/add/:currencyIdA" component={RedirectOldAddLiquidityPathStructure} />
                    <Route exact path="/add/:currencyIdA/:currencyIdB" component={RedirectDuplicateTokenIds} />
                    <Route exact path="/remove/:tokens" component={RedirectOldRemoveLiquidityPathStructure} />
                    {/* <Route component={RedirectPathToSwapOnly} /> */}
                  </Switch>
                  <Marginer />
                </BodyWrapper>
              </Menu>
            </AppWrapper>
          </Switch>
        </HashRouter>
      </Web3ReactManager>
    </Suspense>
  )
}
